import { apiSlice } from "../../app/api/apiSlice";

export const getOBLoanDataApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getOBLoanData: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/get_ob_loan_data/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useGetOBLoanDataMutation } = getOBLoanDataApiSlice;
